// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_AprovarDeparaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/catalogo/depara
 * (controllers/migration/catalogo.php::depara).
 *
 * Quantas decisoes ficaram gravadas e, LINHA A LINHA, quais nao ficaram e por
 * que. A lista de recusadas nao e detalhe de erro: aprovar um de-para e um
 * ato de conferencia, e a pessoa precisa saber exatamente qual das 40 linhas
 * nao pegou — um total que nao bate, sem dizer onde, e pior que uma recusa.
 */
import type { Migration_DeparaRecusaRow } from './Migration_DeparaRecusaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_AprovarDeparaResponseDados {
gravadas: number
recusadas: Migration_DeparaRecusaRow[]
}

export type Migration_AprovarDeparaResponse = ApiResponse<Migration_AprovarDeparaResponseDados>;

registerResponseContract('Migration_AprovarDeparaResponse', {
  gravadas:  { type: 'number',  required: true },
  recusadas: {
    type: 'array',
    required: true,
    items: {
      papel:        { type: 'string',  required: false },
      chave_origem: { type: 'string',  required: false },
      motivo:       { type: 'string',  required: false },
    },
  },
})
